<template>
  <div class="payment">
    <div
      v-if="mode === 'payment'"
      class="payment__time-count"
    >
      <div>{{ $t('book.remaining_payment') }}</div>
      <strong>{{ minutes }}:{{ seconds }}</strong>
    </div>
    <div :class="['payment__container', {'payment__container--flex-revert': mode === 'payment'}]">
      <!--   Case payment   -->
      <div
        v-if="mode === 'payment'"
        class="payment__methods"
      >
        <div class="payment__title">{{ $t('book.pay_info') }}</div>
        <div class="payment__content">
          <div>
            <div class="payment__title">{{ $t('book.pick_up_1') }}</div>
            <div style="line-height: 24px;">
              {{ get(bookingInfo, 'pickup', '') }}<br>
              <i>{{ get(bookingInfo, 'pickup_address', '') }}</i><br>
              {{ $t('book.time') }}: <strong>{{ formatTime(get(bookingInfo, 'pickup_date', '')) }}</strong>
            </div>
            <hr>
            <div class="payment__title">{{ $t('book.drop_off_1') }}</div>
            <div style="line-height: 24px;">
              {{ get(bookingInfo, 'drop_off_info', '') }}<br>
              <i>{{ get(bookingInfo, 'drop_off_address', '') }}</i><br>
              {{ $t('book.time') }}: <strong>{{ formatTime(get(bookingInfo, 'arrival_time', '')) }}</strong>
            </div>
            <button-common
                class="payment__action"
                :loading="payment_loading"
                :label="$t('book.complete_booking')"
                @onClick="handelReserve"
            />
          </div>
        </div>
      </div>
      <!--   Case success   -->
      <div
        v-else-if="mode === 'success'"
        class="payment__methods"
      >
        <div class="payment__title payment__title--success">{{ $t('book.successful_booking') }}</div>
        <p>{{ $t('book.payment_notification', { email: get(bookingInfo, 'customer_email', '') }) }}</p>
        <div
          class="panel panel--success"
          v-html="$t('book.payment_success_note', { booking_code: ticketCode, booking_time })"
        />
        <hr>
        <div class="payment__title">{{ $t('book.pick_up_1') }}</div>
        <div style="line-height: 24px;">
          {{ get(bookingInfo, 'pickup', '') }}<br>
          <i>{{ get(bookingInfo, 'pickup_address', '') }}</i><br>
          {{ $t('book.time') }}: <strong>{{ formatTime(get(bookingInfo, 'pickup_date', '')) }}</strong>
        </div>
        <hr>
        <div class="payment__title">{{ $t('book.drop_off_1') }}</div>
        <div style="line-height: 24px;">
          {{ get(bookingInfo, 'drop_off_info', '') }}<br>
          <i>{{ get(bookingInfo, 'drop_off_address', '') }}</i><br>
          {{ $t('book.time') }}: <strong>{{ formatTime(get(bookingInfo, 'arrival_time', '')) }}</strong>
        </div>
        <div v-if="paymentUrl">
          <a :href="paymentUrl" class="payment__action payment__action--pay">{{ $t('book.pay_now') }}</a>
        </div>
        <hr>
        <div v-if="bookingInfo?.refundable" class="payment__refunds-box">
          <div class="payment__title">{{ $t('book.policy') }}</div>
          <div>
            {{ $t('book.cancel_refunds') }}
            <div class="panel panel--danger">
              {{ $t('book.cancel_note_common') }}
            </div>
            <button-common
              class="payment__action payment__action--cancel"
              style="width: auto;padding: 8px 10px;"
              :loading="cancel_loading"
              :label="$t('book.cancellation_tickets')"
              @onClick="is_show_cancel_modal = true"
            />
          </div>
        </div>
      </div>
      <!--   Case Error   -->
      <div
          v-else-if="mode === 'error'"
          class="payment__methods"
      >
        <div class="payment__title payment__title--error">{{ $t('common.something_went_wrong') }}</div>
        <div style="text-align: center">
          <img class="img-responsive" src="/public/images/route-no-schedule.png">
          <div v-html="$t('common.something_went_wrong_content')" />
        </div>
        <div>
          <button-common
              class="payment__action"
              label="Quay về trang chủ"
              @onClick="goHome"
          />
        </div>
      </div>
      <!--   Case canceled   -->
      <div
          v-else-if="mode === 'cancel'"
          class="payment__methods"
      >
        <div class="payment__title payment__title--error">{{ $t('book.ticket_cancel') }}</div>
        <div v-if="is_show_cancel_note" style="margin-bottom: 10px">
          {{ $t('book.cancel_note_1') }}
        </div>
        <div>
          <img src="/public/images/route-no-schedule.png">
        </div>
        <div>
          <button-common
              class="payment__action payment__action--cancel"
              :label="$t('common.rebook_tickets')"
              @onClick="goHomeBooking"
          />
        </div>
      </div>
      <div class="payment__trip-info">
        <TripInfo
          :booking-info="bookingInfo"
          :payment-type="payment_type"
          :booking-success-info="booking_success_info"
          :mode="mode"
        />
      </div>
      <div style="clear: both" />
      <div v-if="mode === 'success' && bookingInfo?.refundable" class="payment__refunds-box payment__refunds-box--show-sp">
        <div class="payment__title">{{ $t('book.policy') }}</div>
        <div>
          {{ $t('book.cancel_refunds') }}
          <div class="panel panel--danger">
            {{ $t('book.cancel_note_common') }}
          </div>
          <button-common
              class="payment__action payment__action--cancel"
              style="width: auto;padding: 8px 10px;"
              :loading="cancel_loading"
              :label="$t('book.cancellation_tickets')"
              @onClick="is_show_cancel_modal = true"
          />
        </div>
      </div>
    </div>
    <cancel-modal
      v-show="is_show_cancel_modal"
      :ticket-code="ticketCode"
      :booking-code="bookingCode"
      :total-fare="totalFare"
      :service-fee="serviceFee"
      @close="is_show_cancel_modal = false"
      @set-cancel-loading="setCancelLoading"
      @set-mode="setModeAfterCancel"
    />
  </div>
</template>

<script>
import {formatMoney} from "../../../utils/helpers";
import {get, isEmpty} from "lodash";
import ButtonCommon from "../../button/index";
import CancelModal from "../cancel/modal-cancel"
import TripInfo from "../../trip-info/index"

export default {
  components: {
    ButtonCommon,
    CancelModal,
    TripInfo
  },
  data () {
    return {
      count_down: 300,
      payment_type: 1,
      payment_note: '',
      qr_code: appUrl + '/public/images/qr-code.jpg',
      qr_type_img: appUrl + '/public/images/qr.png',
      direct_type_img: appUrl + '/public/images/tt.png',
      booking_success_info: {},
      payment_loading: false,
      is_show_cancel_modal: false,
      cancel_loading: false,
      mode: 'payment',
      booking_time: '',
      is_show_cancel_note: false
    }
  },
  computed: {
    minutes() {
      return Math.floor(this.count_down / 60)
          .toString()
          .padStart(2, "0");
    },
    seconds() {
      return (this.count_down % 60).toString().padStart(2, "0");
    },
    bookingInfo() {
      return this.$store.state.booking.booking_info
    },
    ticketCode() {
      return get(this.booking_success_info, "code", '')
    },
    bookingCode() {
      return get(this.booking_success_info, "booking_code", '')
    },
    paymentUrl() {
      return get(this.booking_success_info, "paymentUrl", '')
    },
    surchargeTotal () {
      return this.bookingInfo?.seat_chooses.length *
          (parseInt(this.bookingInfo.surcharge_pickup) + parseInt(this.bookingInfo.surcharge_drop_off))
    },
    totalFare () {
      return parseInt(this.bookingInfo?.total_fare || 0)
    },
    serviceFee() {
      return parseInt(serviceFee || 0)
    }
  },
  created() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.count_down--;
      if (this.count_down === 0) {
        clearInterval(this.timer);
        window.location.href = appUrl;
      }
    }, 1000);
  },
  methods: {
    get,
    formatMoney,
    formatTime(val) {
      if (!val) {
        return "";
      }
      return moment(val).format("HH:mm  •  DD/MM/YYYY");
    },
    handelReserve () {
      const createdAt = moment();
      const dataBooking = {
        ...this.bookingInfo,
        payment_type: this.payment_type,
        payment_note: this.payment_note,
        created_at: createdAt.format("YYYY/MM/DD HH:mm:ss"),
        surcharge_total: this.surchargeTotal,
        locale: this.$i18n.locale,
      }
      this.payment_loading = true
      this.$store.dispatch('booking', dataBooking)
        .then((result) => {
          this.payment_loading = false
          const data = get(result, "data.data", {});
          if (isEmpty(data)) {
            this.$store.commit('setIsErrorServer', true)
            return
          }

          this.booking_success_info = data
          this.booking_time = createdAt.add(20, 'minutes').format("HH:mm [Ngày] DD/MM/YYYY")
          this.mode = 'success';
          clearInterval(this.timer);
        })
        .catch((e) => {
          this.$store.commit('setIsErrorServer', true)
        })
    },
    goHome () {
      window.location.href = appUrl;
    },
    goHomeBooking () {
      window.location.href = appUrl + '/' +
          (this.$i18n.locale === "vn" ? 'vn/dat-xe-online.html' : 'sleeper-bus-tickets-booking.html');
    },
    setMode (mode) {
      this.mode = mode;
      clearInterval(this.timer);
    },
    setModeAfterCancel (data) {
      this.mode = data.mode;
      if (data.mode === 'cancel' && data.data === 4) {
        this.is_show_cancel_note = true
      }
    },
    setCancelLoading (val) {
      this.cancel_loading = val
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
</script>
